import { useState } from "react";

import Seguimiento from "../formularios/Seguimiento";
import classes from "./SeguimientoModal.module.css";
import cancel from "../../img/icono_cancel.png";

function ModalSeguimiento(props) {

  const [modal_cierre_visible, setModal_cierre_visible] = useState(
    false
  );

  function closeModal() {
    props.setShowModalSeguimiento(false);
  }
  
  function funcionesCierre(event) {
    event.stopPropagation();
    setModal_cierre_visible(true);

  }

  return (
    <div
      className={classes.modalContainer}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <div
        className={classes.modal}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <div
          className={classes.closeModal}
          onClick={funcionesCierre}
        >
          <img className={classes.closeModal} src={cancel} alt="" />
        </div>
        <div>
          <Seguimiento
            closeModal={closeModal}
            caso={props.caso}
            key={props.caso ? props.caso.ruc : Date.now()}
            modal_cierre_visible= {modal_cierre_visible}
            setModal_cierre_visible = {setModal_cierre_visible}
          ></Seguimiento>
        </div>
      </div>
    </div>
  );
}

export default ModalSeguimiento;
